import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ButtonComponent } from '../button/button';

@Component({
  selector: 'app-sidebar-plan-widget',
  imports: [MatIconModule, ButtonComponent],
  templateUrl: './sidebar-plan-widget.html',
  styleUrl: './sidebar-plan-widget.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[attr.data-variant]': 'variant()' },
})
export class SidebarPlanWidgetComponent {
  variant = input<'sidebar' | 'inline'>('sidebar');
  message = input('No active subscription');
  actionText = input('Upgrade');
  showAction = input(true);
  action = output<void>();

  onClick(): void {
    this.action.emit();
  }
}
